import { BuilderFieldDivisionTypes } from '../types';

export const BUILDER_FIELD_DIVISIONS: BuilderFieldDivisionTypes.Division[] = [
  'Primary Fields',
  'Elements',
  'Medical History',
  'Section Templates',
];
